import _mergeJSXProps5 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isDef } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { isNotCompleteNumber, getMaxPrecision, isNaN, getRatio, getValidateValue } from './utils';
import InputHandler from './inputHandler'; // prettier-ignore

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
export default {
  name: buildComponentName('InputNumber'),
  inheritAttrs: false,
  props: {
    prefixCls: {
      type: String,
      default: 'ux-input-number'
    },
    value: {
      type: [Number, String],
      // type: Number,
      default: undefined
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    },
    focusOnUpDown: {
      type: Boolean,
      default: true
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: MAX_SAFE_INTEGER
    },
    min: {
      type: Number,
      default: -MAX_SAFE_INTEGER
    },
    step: {
      type: [Number, String],
      default: 1
    },
    useTouch: {
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function,
      default: null
    },
    parser: {
      type: Function,
      default: function _default(val) {
        return val.replace(/[^\w.-]+/g, '');
      }
    },
    precision: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      inputValue: '',
      innerValue: '',
      // input 输入
      inputting: false,
      focused: false,
      autoStepTimer: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size,
          disabled = this.disabled,
          focused = this.focused;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_ref, "".concat(prefixCls, "-focused"), focused), _ref;
    },
    isCanEditable: function isCanEditable() {
      var readonly = this.readonly,
          disalbed = this.disalbed;
      return !readonly && !disalbed;
    },
    bindAttrs: function bindAttrs() {
      var $attrs = this.$attrs,
          autofocus = this.autofocus,
          disabled = this.disabled,
          readonly = this.readonly,
          max = this.max,
          min = this.min,
          step = this.step;
      return _objectSpread({}, $attrs, {
        autofocus: autofocus,
        disabled: disabled,
        readonly: readonly,
        max: max,
        min: min,
        step: step
      });
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          isCanEditable = this.isCanEditable,
          onInput = this.onInput,
          onChange = this.onChange,
          onFocus = this.onFocus,
          onBlur = this.onBlur,
          onKeydown = this.onKeydown,
          onKeyup = this.onKeyup;
      return _objectSpread({}, $listeners, {
        change: onChange,
        input: onInput,
        focus: onFocus,
        blur: onBlur,
        keydown: isCanEditable ? onKeydown : function () {},
        keyup: isCanEditable ? onKeyup : function () {}
      });
    },
    upDisabledClass: function upDisabledClass() {
      var prefixCls = this.prefixCls,
          innerValue = this.innerValue,
          max = this.max;
      var r = false;

      if (innerValue || innerValue === 0) {
        // like Number.isNaN
        if (!isNaN(Number(innerValue))) {
          var val = Number(innerValue);

          if (val >= max) {
            r = true;
          }
        } else {
          r = true;
        }
      }

      return r ? "".concat(prefixCls, "-handler-up-disabled") : null;
    },
    downDisabledClass: function downDisabledClass() {
      var prefixCls = this.prefixCls,
          innerValue = this.innerValue,
          min = this.min;
      var r = false;

      if (innerValue || innerValue === 0) {
        // like Number.isNaN
        if (!isNaN(Number(innerValue))) {
          var val = Number(innerValue);

          if (val <= min) {
            r = true;
          }
        } else {
          r = true;
        }
      }

      return r ? "".concat(prefixCls, "-handler-down-disabled") : null;
    },
    formatValue: function formatValue() {
      var innerValue = this.innerValue,
          formatter = this.formatter;

      if (formatter) {
        return formatter(innerValue);
      }

      return innerValue;
    }
  },
  // watch: {
  //   value() {
  //     this.initValue();
  //   },
  // },
  created: function created() {
    var _this = this;

    this.initValue();
    this.focused = this.autofocus;
    this.$watch(function () {
      return {
        value: _this.value,
        max: _this.max,
        min: _this.min
      };
    }, function () {
      _this.initValue();
    });
  },
  methods: {
    initValue: function initValue() {
      var innerValue = this.innerValue,
          value = this.value,
          normalizeValue = this.normalizeValue;
      var nVal = parseFloat(value, 10);

      if (!isNaN(nVal)) {
        nVal = normalizeValue(nVal);
      } else {
        nVal = value;
      }

      nVal = getValidateValue(nVal);

      if (innerValue !== nVal) {
        this.innerValue = nVal;

        if (isDef(nVal) && String(value) !== String(nVal)) {
          this.$emit('input', nVal);
          this.$emit('input-change', nVal);
        }
      }
    },
    toNumber: function toNumber(v) {
      var precision = this.precision;
      if (isNotCompleteNumber(v)) return v;

      if (precision !== null) {
        return Number(Number(v).toFixed(precision));
      }

      return Number(v);
    },
    getValidValue: function getValidValue(val) {
      var max = this.max,
          min = this.min;
      var r = Number(val);

      if (r < min) {
        r = min;
      }

      if (r > max) {
        r = max;
      }

      return r;
    },
    getCurrentValidValue: function getCurrentValidValue(val) {
      var innerValue = this.innerValue,
          getValidValue = this.getValidValue,
          toNumber = this.toNumber;

      if (val === '') {
        return val;
      }

      var r = innerValue;

      if (!isNotCompleteNumber(val)) {
        r = getValidValue(val);
      }

      return toNumber(r);
    },
    toPrecision: function toPrecision(val) {
      var step = this.step,
          defaultPrecision = this.precision;

      if (!isDef(val) || val === '') {
        return val;
      }

      var precision = getMaxPrecision(val, step, 1, defaultPrecision);

      if (precision > 0) {
        return Number(val).toFixed(precision);
      }

      return String(val);
    },
    onInputChange: function onInputChange(value) {
      this.$emit('input-change', value);
    },
    normalizeValue: function normalizeValue(val) {
      var getCurrentValidValue = this.getCurrentValidValue,
          toPrecision = this.toPrecision;
      var nVal = getCurrentValidValue(val);
      return toPrecision(nVal);
    },
    setValue: function setValue(val) {
      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var innerValue = this.innerValue,
          inputValue = this.inputValue,
          normalizeValue = this.normalizeValue,
          onInputChange = this.onInputChange;
      var nVal = getValidateValue(normalizeValue(val));
      this.innerValue = nVal;

      if (nVal !== innerValue) {
        this.$emit('input', nVal);
        this.$emit('change', nVal);
      } // 当 输入的字符为无效字符时,会重置为上一个有效值, 此时由于值未变更, vue无法判定是否需要重绘, 需手动触发重绘


      if (forceUpdate && nVal === innerValue) {
        this.$forceUpdate();
      }

      if (nVal !== innerValue || nVal !== inputValue) {
        onInputChange(nVal);
      }
    },
    stop: function stop() {
      var autoStepTimer = this.autoStepTimer;

      if (autoStepTimer) {
        clearTimeout(autoStepTimer);
      }
    },
    upStep: function upStep(val) {
      var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var precisionFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var precision = arguments.length > 3 ? arguments[3] : undefined;
      var step = this.step; // prettier-ignore

      return ((precisionFactor * val + precisionFactor * step * ratio) / precisionFactor).toFixed(precision);
    },
    downStep: function downStep(val) {
      var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var precisionFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var precision = arguments.length > 3 ? arguments[3] : undefined;
      var step = this.step; // prettier-ignore

      return ((precisionFactor * val - precisionFactor * step * ratio) / precisionFactor).toFixed(precision);
    },
    pStep: function pStep(e, type) {
      var _this2 = this;

      var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var autoStep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var recursive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var min = this.min,
          max = this.max,
          innerValue = this.innerValue,
          inputValue = this.inputValue,
          inputting = this.inputting,
          upStep = this.upStep,
          downStep = this.downStep,
          toNumber = this.toNumber,
          getCurrentValidValue = this.getCurrentValidValue,
          setValue = this.setValue,
          step = this.step,
          defaultPrecision = this.precision,
          stop = this.stop;
      stop();

      if (e) {
        e.preventDefault();

        if (e.button !== 0 && e.keyCode !== 38 && e.keyCode !== 40) {
          return;
        }
      }

      var currentVal = inputting ? inputValue : innerValue;
      var validVal = getCurrentValidValue(currentVal) || 0;
      var stepFn = type === 'up' ? upStep : downStep; // 防止出现除不净的问题,类似: 1.1-1 = 0.10000000000000009

      var precision = getMaxPrecision(validVal, step, ratio, defaultPrecision);
      var precisionFactor = Math.pow(10, precision);
      var val = toNumber(stepFn(validVal, ratio, precisionFactor, precision));
      setValue(val, inputting);
      this.inputting = false;
      this.focused = true;

      if (autoStep && val > min && val < max) {
        this.autoStepTimer = setTimeout(function () {
          _this2[type](e, ratio, true, true);
        }, recursive ? 200 : 600);
      }
    },
    up: function up(e, ratio, autoStep, recursive) {
      var pStep = this.pStep;
      pStep(e, 'up', ratio, autoStep, recursive);
    },
    down: function down(e, ratio, autoStep, recursive) {
      var pStep = this.pStep;
      pStep(e, 'down', ratio, autoStep, recursive);
    },
    onInput: function onInput(e) {
      var parser = this.parser,
          onInputChange = this.onInputChange;
      this.inputting = true;
      var val = e.target.value;
      var inputValue = parser(val.trim().replace(/。/g, '.'));
      this.inputValue = inputValue;
      onInputChange(inputValue);
    },
    onChange: function onChange() {
      var inputValue = this.inputValue;

      if (this.inputting) {
        this.inputting = false;
        this.setValue(inputValue, true);
      }
    },
    onFocus: function onFocus(e) {
      this.focused = true;
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.inputting = false;
      this.focused = false;
      this.$emit('blur', e);
    },
    onKeydown: function onKeydown(e) {
      var up = this.up,
          down = this.down;

      if (e.keyCode === 38) {
        up(e, getRatio(e), false);
      } else if (e.keyCode === 40) {
        down(e, getRatio(e), false);
      }

      this.$emit('keydown', e);
    },
    onKeyup: function onKeyup(e) {
      this.$emit('keyup', e);
    },
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    },
    renderHandlers: function renderHandlers() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          useTouch = this.useTouch,
          isCanEditable = this.isCanEditable,
          upDisabledClass = this.upDisabledClass,
          downDisabledClass = this.downDisabledClass,
          up = this.up,
          down = this.down,
          stop = this.stop;
      var handlerCls = "".concat(prefixCls, "-handler");
      var baseOn = {
        mouseup: stop,
        mouseleave: stop
      };
      var upOn = useTouch ? {
        touchstart: up,
        touchend: stop
      } : _objectSpread({
        mousedown: up
      }, baseOn);
      upOn = isCanEditable && !upDisabledClass ? upOn : null;
      var downOn = useTouch ? {
        touchstart: down,
        touchend: stop
      } : _objectSpread({
        mousedown: down
      }, baseOn);
      downOn = isCanEditable && !downDisabledClass ? downOn : null;
      return h("div", {
        "class": "".concat(prefixCls, "-handler-wrap")
      }, [h(InputHandler, _mergeJSXProps([{}, {
        class: [handlerCls, "".concat(handlerCls, "-up"), upDisabledClass],
        on: upOn
      }]), [h("span", {
        "class": "".concat(handlerCls, "-up-inner")
      })]), h(InputHandler, _mergeJSXProps2([{}, {
        class: [handlerCls, "".concat(handlerCls, "-down"), downDisabledClass],
        on: downOn
      }]), [h("span", {
        "attrs": {
          "unselectable": "unselectable"
        },
        "class": "".concat(handlerCls, "-down-inner")
      })])]);
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          max = this.max,
          min = this.min,
          innerValue = this.innerValue,
          formatValue = this.formatValue,
          bindAttrs = this.bindAttrs,
          bindListeners = this.bindListeners;
      var attrs = {
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': innerValue
      };
      return h("div", _mergeJSXProps4([{}, {
        class: "".concat(prefixCls, "-input-wrap"),
        attrs: attrs
      }]), [h("input", _mergeJSXProps3([{}, {
        class: "".concat(prefixCls, "-input"),
        domProps: {
          value: formatValue
        },
        attrs: bindAttrs,
        on: bindListeners,
        ref: 'inputRef'
      }]))]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        renderHandlers = this.renderHandlers,
        renderInput = this.renderInput;
    return h("div", _mergeJSXProps5([{}, {
      class: classes
    }]), [renderHandlers(), renderInput()]);
  }
};